import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setLanguage } from '@/shared/actions';
import { translate } from '@/services/TranslationService';
import { withNOVOHeader } from '../sideMenu/HeaderHOC';
import { findApplicationTypeByCode } from '../route/routeUtils';
import ActiveSelectedApplication from './ActiveSelectedApplication/ActiveSelectedApplication';
import ApplicationAvailabilitySelection from './ApplicationAvailabilitySelection';
import { APPLICATIONS_SELECTIONS } from './applications-constants';

const Applications = (props) => {
  const { location, setHeaderTitle } = props;
  const dispatch = useDispatch();
  const selectedLanguage = useSelector(
    (state) => state.settingsReducer?.selectedLanguage
  );

  const [selectedSelection, setSelectedSelection] = useState(
    Object.keys(APPLICATIONS_SELECTIONS)[0]
  );

  const [activeApplication, setActiveApplication] = useState(null);
  const [consumedRouteApplicationCode, setConsumedRouteApplicationCode] =
    useState(null);

  const routeApplicationParams = useMemo(() => {
    const params = new URLSearchParams(location.search);

    return {
      authority: params.get('authority') || '',
      code: params.get('code') || '',
      lang: params.get('lang') || params.get('language') || '',
      applicationsLicensePlate: params.get('applications_license_plate') || '',
      applicationsCode: params.get('applications_code') || '',
    };
  }, [location.search]);

  const activeApplicationMetadata = useMemo(() => {
    if (!activeApplication || !routeApplicationParams.code) return null;

    const activeApplicationMatchesRouteCode = !!findApplicationTypeByCode(
      [activeApplication],
      routeApplicationParams.code
    );

    if (!activeApplicationMatchesRouteCode) return null;

    return {
      applicationsLicensePlate:
        routeApplicationParams.applicationsLicensePlate,
      applicationsCode: routeApplicationParams.applicationsCode,
    };
  }, [
    activeApplication,
    routeApplicationParams.applicationsCode,
    routeApplicationParams.applicationsLicensePlate,
    routeApplicationParams.code,
  ]);

  useEffect(() => {
    setHeaderTitle(translate('sideMenu.Applications'));
  }, []);

  useEffect(() => {
    setConsumedRouteApplicationCode(null);
  }, [location.search]);

  useEffect(() => {
    if (!routeApplicationParams.lang) return;
    if (selectedLanguage === routeApplicationParams.lang) return;

    dispatch(setLanguage(routeApplicationParams.lang));
  }, [dispatch, routeApplicationParams.lang, selectedLanguage]);

  const resetActiveApplication = () => {
    setActiveApplication(null);
  };

  const onApplicationSubmitted = () => {
    resetActiveApplication();
    setSelectedSelection('submitted');
  };

  return (
    <div className="flex flex-1 flex-col relative">
      <div className="flex flex-1 flex-col sm:m-10 m-0 sm:max-h-[calc(100vh-10rem)] py-2 sm:px-8 px-0 h-fit  rounded-sm">
        {!activeApplication && (
          <>
            <div className="md:mx-0 mx-auto mb-5 ">
              <ApplicationAvailabilitySelection
                options={APPLICATIONS_SELECTIONS}
                selected={selectedSelection}
                setSelected={setSelectedSelection}
              />
            </div>
            <div className="flex flex-1 flex-col overflow-y-auto">
              {React.createElement(
                APPLICATIONS_SELECTIONS[selectedSelection].component,
                {
                  routeApplicationParams,
                  shouldAutoOpenRouteApplication:
                    !!routeApplicationParams.code &&
                    consumedRouteApplicationCode !==
                      routeApplicationParams.code,
                  onRouteApplicationAutoOpened: () =>
                    setConsumedRouteApplicationCode(
                      routeApplicationParams.code
                    ),
                  setActiveApplication,
                }
              )}
            </div>
          </>
        )}
        {activeApplication && (
          <ActiveSelectedApplication
            activeApplication={activeApplication}
            metadata={activeApplicationMetadata}
            onResetActiveApplication={resetActiveApplication}
            onApplicationSubmitted={onApplicationSubmitted}
          />
        )}
      </div>
    </div>
  );
};

export default withNOVOHeader(withRouter(Applications));
